import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { NotificationItem } from '@/modules/notifications/components/NotificationItem';
import { notificationsPaths } from '@/modules/notifications/paths';
import { useNotifications } from '@/modules/notifications/hooks/useNotifications';
import { useAuth } from '@/shared/hooks/useAuth';
import { IconBell } from '@/shared/components/icons';

export function NotificationDropdown() {
  const { firebaseUser } = useAuth();
  const { notifications, unreadCount, loading, markRead, markAllRead } =
    useNotifications(firebaseUser?.uid);
  const [open, setOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDocClick(e: MouseEvent) {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const recent = notifications.slice(0, 8);

  return (
    <div className="notification-dropdown" ref={panelRef}>
      <button
        type="button"
        className="notification-bell"
        aria-expanded={open}
        aria-label={
          unreadCount > 0
            ? `${unreadCount} notificaciones sin leer`
            : 'Notificaciones'
        }
        onClick={() => setOpen((v) => !v)}
      >
        <IconBell size={20} className="notification-bell__icon" />
        {unreadCount > 0 ? (
          <span className="notification-bell__badge">{unreadCount}</span>
        ) : null}
      </button>

      {open ? (
        <div className="notification-dropdown__panel" role="dialog">
          <header className="notification-dropdown__header">
            <strong>Notificaciones</strong>
            {unreadCount > 0 ? (
              <button
                type="button"
                className="auth-button auth-button--secondary"
                onClick={() => void markAllRead()}
              >
                Marcar todas
              </button>
            ) : null}
          </header>

          {loading ? (
            <p className="auth-muted notification-dropdown__empty">
              Cargando…
            </p>
          ) : null}

          {!loading && recent.length === 0 ? (
            <p className="auth-muted notification-dropdown__empty">
              No tenés notificaciones recientes.
            </p>
          ) : null}

          <ul className="notification-dropdown__list">
            {recent.map((n) => (
              <li key={n.id}>
                <NotificationItem
                  notification={n}
                  compact
                  onMarkRead={(id) => void markRead(id)}
                />
              </li>
            ))}
          </ul>

          <footer className="notification-dropdown__footer">
            <Link
              to={notificationsPaths.list}
              className="auth-link"
              onClick={() => setOpen(false)}
            >
              Ver todas
            </Link>
          </footer>
        </div>
      ) : null}
    </div>
  );
}
